import React, { Component } from 'react';
import ajax from 'superagent';
import { Field } from 'redux-form';
import SelectField from './SelectField';

class EmploymentsList extends Component {

    constructor(props) {
        super(props);
        this.state = { employments: [] };
    }

    componentWillMount() {
        const ROOT_URL = process.env.API_URL;

        ajax.get(ROOT_URL + '/employments')
            .end((error, response) => {
                if (!error && response) {
                    this.setState({ employments: response.body.employments });
                } else {
                    console.log('There was an error fetching from API', error);
                }
            }
        );
    }

    render() {
        return (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field 
                        className="form-control" 
                        name="employment_id" 
                        component={SelectField} 
                        options={this.state.employments} 
                        defaultValue={'Situación Laboral'}
                        label={'Tipo de Empleo'}
                        type={this.props.type}
                    />
                </div>
            </div>
        );
    }
}

export default EmploymentsList;



/** WEBPACK FOOTER **
 ** ./src/components/Employments.js
 **/